export default "__VITE_ASSET__5wbs7V$p__"